var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SeletorDeLojas',_vm._g(_vm._b({attrs:{"usuario":!_vm.possuiAcessoIrrestrito ? _vm.idUsuarioLogado : undefined}},'SeletorDeLojas',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }